const VerticalTabs = ({ activeStep }) => {
  const STEP_NAMES = [
    { title: "Хувийн мэдээлэл", index: 1 },
    { title: "Банкны мэдээлэл", index: 3 },
    { title: "Орлого хуваалт", index: 4 },
    { title: "Баталгаажуулах ", index: 5 },
  ];

  return (
    <div className="flex gap-8">
      <ul className="flex flex-col items-start gap-6">
        {STEP_NAMES.map(({ title, index }) => (
          <li
            key={index}
            className={`text-sm font-semibold cursor-pointer transition-colors
    ${activeStep === index ? "text-mmusic" : "text-[#697D95]"}
    hover:text-mmusic`}
          >
            {index}. {title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default VerticalTabs;
